import r from "../../shared-lib/braze-shared-lib.js";
import FeatureFlag from "./feature-flag.js";
export function newFeatureFlagFromJson(e) {
  if (e[FeatureFlag.Rt.rt] && "boolean" == typeof e[FeatureFlag.Rt.Fe])
    return new FeatureFlag(
      e[FeatureFlag.Rt.rt],
      e[FeatureFlag.Rt.Fe],
      e[FeatureFlag.Rt.we],
      e[FeatureFlag.Rt.ze],
    );
  r.j.info(`Unable to create feature flag from ${JSON.stringify(e, null, 2)}`);
}
export function newFeatureFlagFromSerializedValue(e) {
  if (e[FeatureFlag.it.rt] && "boolean" == typeof e[FeatureFlag.it.Fe])
    return new FeatureFlag(
      e[FeatureFlag.it.rt],
      e[FeatureFlag.it.Fe],
      e[FeatureFlag.it.we],
      e[FeatureFlag.it.ze],
    );
  r.j.info(
    `Unable to deserialize feature flag from ${JSON.stringify(e, null, 2)}`,
  );
}
